module.exports = __webpack_public_path__ + "img/emoji-girl-80x80.de7b9e37.png";